import { createFileRoute } from "@tanstack/react-router"

import { LoginView } from "@/features/auth/components/login-view"
import { redirectIfAuthed, validateAuthSearch } from "@/lib/auth/route-guards"

export const Route = createFileRoute("/login/")({
  validateSearch: validateAuthSearch,
  beforeLoad: ({ context, search }) => redirectIfAuthed({ context, search }),
  // Start downloading the brand panel's WebGL threads the moment the
  // route is entered, in parallel with the page itself, so it's ready by
  // first paint instead of arriving a beat after the panel.
  loader: () => {
    void import("@/components/shared/threads")
  },
  component: LoginRoute,
})

function LoginRoute() {
  const { from } = Route.useSearch()
  return <LoginView from={from} />
}
